export const CONTACT_EMAIL = import.meta.env.VITE_APP_CONTACT_EMAIL || 'support@pageai.co';
export const POST_LOG_OUT_REDIRECT_URL = import.meta.env.VITE_APP_POST_LOG_OUT_REDIRECT_URL as string | undefined;
